import React from 'react';
import { CircularProgress } from '@material-ui/core';

import { Button as StyledButton } from './styles';

const Button = ({isLoading, ...rest}) => (
  isLoading ? (
    <StyledButton disabled {...rest}>
      <CircularProgress color="inherit" />
    </StyledButton>
  ) : (
    <StyledButton {...rest} />
  )
);

export default Button;
